<template>
  <div class="text-center">
    <p class="no-margins" v-if="showCounter">Mostrando de {{ showingOf }} até {{ showingAt }} de {{ registerCount }} registros</p>

    <ul :class="containerClass">
      <li :class="[prevClass, { disabled: firstPageSelected() }]">
        <a @click="prevPage()" @keyup.enter="prevPage()" :class="prevLinkClass" tabindex="0">{{ prevText }}</a>
      </li>
      <li v-for="page in pages" :class="[pageClass, { active: page.selected, disabled: page.disabled }]">
        <a v-if="page.disabled" :class="pageLinkClass" tabindex="0">{{ page.content }}</a>
        <a v-else @click="handlePageSelected(page.index)" 
          @keyup.enter="handlePageSelected(page.index)" 
          :class="pageLinkClass" tabindex="0">{{ page.content }}</a>
      </li>
      <li :class="[nextClass, { disabled: lastPageSelected() }]">
        <a @click="nextPage()" @keyup.enter="nextPage()" :class="nextLinkClass" tabindex="0">{{ nextText }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    pageCount: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number
    },
    registerCount: {
      type: Number
    },
    showCounter: {
      type: Boolean
    },
    initialPage: {
      type: Number,
      default: 0
    },
    forcePage: {
      type: Number
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    pageRange: {
      type: Number,
      default: 10
    },
    marginPages: {
      type: Number,
      default: 1
    },
    prevText: {
      type: String,
      default: 'Anterior'
    },
    nextText: {
      type: String,
      default: 'Próximo'
    },
    containerClass: {
      type: String,
      default: 'pagination'
    },
    pageClass: {
      type: String
    },
    pageLinkClass: {
      type: String
    },
    prevClass: {
      type: String
    },
    prevLinkClass:{
      type: String
    },
    nextClass: {
      type: String
    },
    nextLinkClass: {
      type: String
    }
  },
  data () {
    return {
      selected: this.initialPage
    }
  },
  beforeUpdate() {
    if (this.forcePage === undefined) return
    if (this.forcePage !== this.selected) {
      this.selected = this.forcePage
    }
  },
  computed: {
    pages: function () {
      let items = {}
      if (this.pageCount <= this.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected
          }
          items[index] = page
        }
      } else {
        let leftPart = this.pageRange / 2
        let rightPart = this.pageRange - leftPart
        if (this.selected < leftPart) {
          leftPart = this.selected
          rightPart = this.pageRange - leftPart
        } else if (this.selected > this.pageCount - this.pageRange / 2) {
          rightPart = this.pageCount - this.selected
          leftPart = this.pageRange - rightPart
        }
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected
          }
          if (index <= this.marginPages - 1 || index >= this.pageCount - this.marginPages) {
            items[index] = page
            continue
          }
          let breakView = {
            content: '...',
            disabled: true
          }
          if ((this.selected - leftPart) > this.marginPages && items[this.marginPages] !== breakView) {
            items[this.marginPages] = breakView
          }
          if ((this.selected + rightPart) < (this.pageCount - this.marginPages - 1) && items[this.pageCount - this.marginPages - 1] !== breakView) {
            items[this.pageCount - this.marginPages - 1] = breakView
          }
          let overCount = this.selected + rightPart - this.pageCount + 1
          if (overCount > 0 && index === this.selected - leftPart - overCount) {
            items[index] = page
          }
          if ((index >= this.selected - leftPart) && (index <= this.selected + rightPart)) {
            items[index] = page
            continue
          }
        }
      }
      return items
    },
    showingOf: function() {
      return ((this.selected + 1) * this.perPage) - this.perPage + 1;
    },
    showingAt: function() {
      let showingOf = this.showingOf;
      let at = (this.selected * this.perPage) + this.perPage;

      return at > this.registerCount ? this.registerCount : at;
    }
  },
  methods: {
    handlePageSelected (selected) {
      if (this.selected === selected) return
      this.selected = selected
      this.clickHandler(this.selected + 1)
    },
    prevPage () {
      if (this.selected <= 0) return
      this.selected --
      this.clickHandler(this.selected + 1)
    },
    nextPage () {
      if (this.selected >= this.pageCount - 1) return
      this.selected ++
      this.clickHandler(this.selected + 1)
    },
    firstPageSelected() {
      return this.selected === 0
    },
    lastPageSelected() {
      return this.selected === this.pageCount - 1
    }
  }
}
</script>


// WEBPACK FOOTER //
// FrontEnd/componentes/Paginacao.vue